// extracted by mini-css-extract-plugin
export default {"resetButton":"t63rWsg","stubWrapper":"ARVmtD4","stubBackground":"PfMETts","messageContainer":"O52fYq1","closeButton":"t19xQwd"};